export enum ManualAssessmentType {
  VIDEO = 'video',
  AUDIO = 'audio',
  FILE_UPLOAD = 'document',
  SCREEN = 'screen',
  IMAGE = 'image',
  TEXT = 'text'
}
